import { createColumnHelper } from '@tanstack/react-table';
import { useGetFeatureFlagsQuery } from 'gcs-common/clients/api/entities/feature-flags/feature-flags-api';
import type { FetchFeatureFlagsResponseData } from 'gcs-common/clients/api/entities/feature-flags/feature-flags-api-helpers';
import { DataTable } from 'gcs-common/design-system/ui/data-table';
import { fetchTenantSelectOptions } from 'gcs-common/slices/administration/tenants/tenantsThunks';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AdminTableTitle from '../AdminTableTitle/AdminTableTitle';
import FeatureFlagHousesCell from './FeatureFlagHousesCell/FeatureFlagHousesCell';
import FeatureFlagTenantsCell from './FeatureFlagTenantsCell/FeatureFlagTenantsCell';
import FeatureFlagUsersCell from './FeatureFlagUsersCell/FeatureFlagUsersCell';

const columnHelper = createColumnHelper<FetchFeatureFlagsResponseData['data'][number]>();

const columns = [
  columnHelper.accessor('key', {
    id: 'key',
    header: 'Feature Flag',
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor('tenants', {
    id: 'tenants',
    header: 'Tenants',
    cell: (info) => <FeatureFlagTenantsCell cell={info.cell} value={info.getValue()} />,
  }),
  columnHelper.accessor('houses', {
    id: 'houses',
    header: 'Häuser',
    cell: (info) => <FeatureFlagHousesCell cell={info.cell} value={info.getValue()} />,
  }),
  columnHelper.accessor('users', {
    id: 'users',
    header: 'Nutzer',
    cell: (info) => <FeatureFlagUsersCell cell={info.cell} value={info.getValue()} />,
  }),
];

const FeatureFlagsOverview = () => {
  const dispatch = useDispatch();
  const { data, isLoading } = useGetFeatureFlagsQuery();
  const featureFlags = data?.data || [];

  useEffect(() => {
    // TODO migrate soon
    dispatch(fetchTenantSelectOptions());
  }, [dispatch]);

  return (
    <>
      <AdminTableTitle title="Feature Flags" numberOfItems={featureFlags.length} isLoading={isLoading} />
      <DataTable
        // @ts-expect-error: no idea. Something with the TValue in the DataTable props
        columns={columns}
        data={featureFlags}
        classNames={{
          tableRow: 'hover:bg-white-light',
        }}
      />
    </>
  );
};

export default FeatureFlagsOverview;
